import script from "./IframeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeItem.vue?vue&type=script&setup=true&lang=js"

import "./IframeItem.vue?vue&type=style&index=0&id=487d8a1b&lang=scss"

const __exports__ = script;

export default __exports__